(function () {
    'ngInject';

    angular.module('app.shared.services').factory('ExecutionService', fontManagerService);

    function fontManagerService() {
        const callFunction = async (func) => {
            return new Promise((resolve, reject) => {
                requestAnimationFrame(async () => {
                    try {
                        await Promise.resolve(func());
                        resolve();
                    } catch (error) {
                        console.error(error);
                        reject(error);
                    }
                });
            });
        };

        const delayedExecution = async (func) => {
            await callFunction(func);
        };

        const runTasksInChunks = async (tasks, chunkSize = 6) => {
            // Make sure tasks list is not empty otherwise asyncPool() will throw
            tasks = tasks || [];
            if (!tasks.length) {
                return [];
            }

            return await asyncPool(chunkSize, tasks, async (task) => {
                return await task();
            });
        };

        return {
            delayedExecution: delayedExecution,
            runTasksInChunks: runTasksInChunks
        };
    }
})();
